import {register} from '@shopify/theme-sections';
import Product from '../ui/product-types/base';

register('product', Product);
